import { render, staticRenderFns } from "./product-auto-select.vue?vue&type=template&id=0cf1a299&scoped=true"
import script from "./product-auto-select.vue?vue&type=script&lang=js"
export * from "./product-auto-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf1a299",
  null
  
)

export default component.exports